import { PropsWithChildren } from 'react';
import type { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';
import { EntityActivityLogItemSkeleton } from './EntityActivityLogItemSkeleton';

const SKELETON_COUNT = 4;

interface EntityActivityLogListProps extends PropsWithChildren {
  isLoading: boolean;
  isEmpty: boolean;
  emptyLabel: string;
  /** Sentry element for infinite-scroll pagination (infinite-scroll entities only). */
  loadMoreRef?: UseInfiniteScrollHookRefCallback;
  showLoadMore?: boolean;
}

export const EntityActivityLogList = ({
  isLoading,
  isEmpty,
  emptyLabel,
  children,
  loadMoreRef,
  showLoadMore,
}: EntityActivityLogListProps) => {
  if (isLoading)
    return (
      <div className="flex flex-col gap-3">
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          <EntityActivityLogItemSkeleton
            key={`activity-log-skeleton-${index}`}
          />
        ))}
      </div>
    );

  if (isEmpty)
    return <p className="text-muted-foreground py-6 text-sm">{emptyLabel}</p>;

  return (
    <div>
      {children}

      {showLoadMore && (
        <div ref={loadMoreRef} className="flex flex-col gap-3">
          <EntityActivityLogItemSkeleton />
        </div>
      )}
    </div>
  );
};
